import { InjectionToken } from '@angular/core';

export const TRACK_DESCENDANTS_FOCUS = new InjectionToken<boolean>('[tkKeyboardFocusMonitor] monitor descendants');
